import * as React from 'react';

import { PageTitleBar } from 'components';

const PurchaseHeader = ({ children }: React.PropsWithChildren<unknown>) => (
  <PageTitleBar headerTitle={children} />
);

export { PurchaseHeader };
